import Vue from 'vue';
import Router from 'vue-router';
// import Dashboard from './components/Dashboard.vue';

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			name: 'main',
			component: () => import('./pages/MainPage'),
			children: [
				{
					path: 'dashboard',
					name: 'dashboard',
					component: () => import('./components/Dashboard')
				},
				{
					path: 'report-carpark',
					name: 'report-carpark',
					component: () => import('./components/Report/CarPark')
				},
				{
					path: 'report-client',
					name: 'report-client',
					component: () => import('./components/Report/Client')
				},
				{
					path: 'report-customer',
					name: 'report-customer',
					component: () => import('./components/Report/Customer')
				},
				{
					path: 'report-daily',
					name: 'report-daily',
					component: () => import('./components/Report/Daily')
				},
				{
					path: 'role',
					component: () => import('./components/Role/ListRole')
				},
				{
					path: 'user',
					component: () => import('./components/User/ListUser')
				},
				// {
				// 	path: 'cities',
				// 	component: () => import('./components/City/ListCity')
				// },
				{
					path: 'clients',
					name: 'clients',
					component: () => import('./components/Client/ListClients')
				},
				{
					path: 'client/edit/:id',
					name: 'edit-client',
					component: () => import('./components/Client/EditClient')
				},
				{
					path: 'client',
					name: 'client',
					component: () => import('./components/Client/NewClient.vue'),
					children: [
						{
							path: 'general',
							name: 'client-general',
							component: () => import('./components/Client/GeneralInfo.vue'),
						},
						{
							path: 'park',
							name: 'client-park',
							component: () => import('./components/Client/CarPark.vue'),
						},
						{
							path: 'staff',
							name: 'client-staff',
							component: () => import('./components/Client/Staff.vue'),
						},
						{
							path: 'confirmation',
							name: 'client-confirmation',
							component: () => import('./components/Client/Confirmation.vue'),
						},
					]
				},
				{
					path: 'carparks',
					name: 'carparks',
					component: () => import('./components/CarPark/ListCarPark')
				},
				{
					path: 'charities',
					name: 'charities',
					component: () => import('./components/Charity/ListCharity')
				},
				{
					path: 'charity/edit/:id',
					name: 'edit-charity',
					component: () => import('./components/Charity/EditCharity')
				},
				{
					path: 'charity',
					name: 'charity',
					component: () => import('./components/Charity/NewCharity.vue'),
					children: [
						{
							path: 'general',
							name: 'charity-general',
							component: () => import('./components/Charity/GeneralInfo.vue'),
						},
						{
							path: 'staff',
							name: 'charity-staff',
							component: () => import('./components/Charity/Staff.vue'),
						},
						{
							path: 'confirmation',
							name: 'charity-confirmation',
							component: () => import('./components/Charity/Confirmation.vue'),
						},
					]
				},
			]
		},
		{
			path: '/login',
			name: 'login',
			props: "",
			component: () => import('./pages/LoginPage.vue')
		},
		{
			path: '/forgot',
			name: 'forgot',
			props: "",
			component: () => import('./pages/ForgotPage.vue')
		},
		{
			path: '/reset/:token',
			name: 'reset',
			props: "",
			component: () => import('./pages/ResetPage.vue')
		},
	],
	mode: "history",
	// routes: [
	// 	{
	// 		path: '/',
	// 		name: 'dashboard',
	// 		component: Dashboard
	// 	},
	// 	{
	// 		path: '/formlayout',
	// 		name: 'formlayout',
	// 		component: () => import('./components/FormLayoutDemo.vue')
	// 	},
	// 	{
	// 		path: '/input',
	// 		name: 'input',
	// 		component: () => import('./components/InputDemo.vue')
	// 	},
	// 	{
	// 		path: '/button',
	// 		name: 'button',
	// 		component: () => import('./components/ButtonDemo.vue')
	// 	},
	// 	{
	// 		path: '/table',
	// 		name: 'table',
	// 		component: () => import('./components/TableDemo.vue')
	// 	},
	// 	{
	// 		path: '/list',
	// 		name: 'list',
	// 		component: () => import('./components/ListDemo.vue')
	// 	},
	// 	{
	// 		path: '/tree',
	// 		name: 'tree',
	// 		component: () => import('./components/TreeDemo.vue')
	// 	},
	// 	{
	// 		path: '/panel',
	// 		name: 'panel',
	// 		component: () => import('./components/PanelsDemo.vue')
	// 	},
	// 	{
	// 		path: '/overlay',
	// 		name: 'overlay',
	// 		component: () => import('./components/OverlayDemo.vue')
	// 	},
	// 	{
	// 		path: '/menu',
    //         component: () => import('./components/MenuDemo.vue'),
    //         children: [{
    //             path: '',
    //             component: () => import('./components/menu/PersonalDemo.vue')
    //         },
    //         {
    //             path: '/menu/seat',
    //             component: () => import('./components/menu/SeatDemo.vue')
    //         },
    //         {
    //             path: '/menu/payment',
    //             component: () => import('./components/menu/PaymentDemo.vue')
    //         },
    //         {
    //             path: '/menu/confirmation',
    //             component: () => import('./components/menu/ConfirmationDemo.vue')
    //         }]
    //     },
	// 	{
	// 		path: '/messages',
	// 		name: 'messages',
	// 		component: () => import('./components/MessagesDemo.vue')
	// 	},
	// 	{
	// 		path: '/file',
	// 		name: 'file',
	// 		component: () => import('./components/FileDemo.vue')
	// 	},
	// 	{
	// 		path: '/chart',
	// 		name: 'chart',
	// 		component: () => import('./components/ChartDemo.vue')
	// 	},
	// 	{
	// 		path: '/misc',
	// 		name: 'misc',
	// 		component: () => import('./components/MiscDemo.vue')
	// 	},
	// 	{
	// 		path: '/display',
	// 		name: 'display',
	// 		component: () => import('./utilities/DisplayDemo.vue')
	// 	},
	// 	{
	// 		path: '/flexbox',
	// 		name: 'flexbox',
	// 		component: () => import('./utilities/FlexBoxDemo.vue')
	// 	},
	// 	{
	// 		path: '/text',
	// 		name: 'text',
	// 		component: () => import('./utilities/TextDemo.vue')
	// 	},
	// 	{
	// 		path: '/icons',
	// 		name: 'icons',
	// 		component: () => import('./utilities/Icons.vue')
	// 	},
	// 	{
	// 		path: '/grid',
	// 		name: 'grid',
	// 		component: () => import('./utilities/GridDemo.vue')
	// 	},
	// 	{
	// 		path: '/spacing',
	// 		name: 'spacing',
	// 		component: () => import('./utilities/SpacingDemo.vue')
	// 	},
	// 	{
	// 		path: '/elevation',
	// 		name: 'elevation',
	// 		component: () => import('./utilities/ElevationDemo.vue')
	// 	},
	// 	{
	// 		path: '/typography',
	// 		name: 'typography',
	// 		component: () => import('./utilities/Typography.vue')
	// 	},
	// 	{
	// 		path: '/crud',
	// 		name: 'crud',
	// 		component: () => import('./pages/CrudDemo.vue')
	// 	},
	// 	{
	// 		path: '/calendar',
	// 		name: 'calendar',
	// 		component: () => import('./pages/CalendarDemo.vue')
	// 	},
	// 	{
	// 		path: '/empty',
	// 		name: 'empty',
	// 		component: () => import('./components/Dashboard.vue')
	// 	},
	// 	{
	// 		path: '/documentation',
	// 		name: 'documentation',
	// 		component: () => import('./components/Documentation.vue')
	// 	},
	// ],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});
